import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  MatPseudoCheckboxState,
  MatOptgroup,
  MatOption,
  MatPseudoCheckbox,
} from '@angular/material/core';
import { FormlyFieldSelect } from '@ngx-formly/material/select';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { NgFor, NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormlyCostcenterSelectOptionsPipe } from './formly-costcenter-select-options.pipe';

@Component({
  selector: 'app-formly-costcenter-select',
  template: `
    <ng-template #selectAll let-selectOptions="selectOptions">
      <mat-option (click)="toggleSelectAll(selectOptions)">
        <mat-pseudo-checkbox
          class="mat-option-pseudo-checkbox"
          [state]="_getSelectAllState(selectOptions)"
        >
        </mat-pseudo-checkbox>
        {{ to.selectAllOption }}
      </mat-option>
    </ng-template>
    <mat-select
      panelClass="costcenter-select-panel"
      [id]="id"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [placeholder]="props.placeholder ?? ''"
      [tabIndex]="props.tabindex"
      [required]="required"
      [compareWith]="props.compareWith ?? defaultOptions.props.compareWith"
      [multiple]="props.multiple"
      (selectionChange)="change($event)"
      [errorStateMatcher]="errorStateMatcher"
      [disableOptionCentering]="props.disableOptionCentering"
      [typeaheadDebounceInterval]="props.typeaheadDebounceInterval"
    >
      <mat-select-trigger>
        <ng-container
          *ngFor="
            let opt of props.options
              | formlyCostcenterSelectOptions: field
              | async as selectOptions
          "
        >
          @if (opt.value === formControl.value) {
            {{ opt.label }}
          }
        </ng-container>
      </mat-select-trigger>

      @if (
        props.options | formlyCostcenterSelectOptions: field | async;
        as selectOptions
      ) {
        @if (props.multiple && props.selectAllOption) {
          <ng-container
            [ngTemplateOutlet]="selectAll"
            [ngTemplateOutletContext]="{
              selectOptions: selectOptions,
            }"
          >
          </ng-container>
        }
        @for (item of selectOptions; track item) {
          @if (item.group) {
            <mat-optgroup [label]="item.label">
              @for (child of item.group; track child) {
                <mat-option [value]="child.value" [disabled]="child.disabled">
                  {{ child.label }}
                </mat-option>
              }
            </mat-optgroup>
          }
          @if (!item.group) {
            <mat-option [value]="item.value" [disabled]="item.disabled">
              {{ item.label }}
              @if (item.data?.officerUserId) {
                <span class="small"
                  ><br />{{ 'SHARED.COSTCENTER_SELECT.OFFICER' | translate }}
                  {{ item.data?.officerUserId }}</span
                >
              }
            </mat-option>
          }
        }
      }
    </mat-select>
  `,
  styleUrls: ['./formly-costcenter-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatSelect,
    ReactiveFormsModule,
    FormlyModule,
    MatSelectTrigger,
    NgFor,
    NgTemplateOutlet,
    MatOptgroup,
    MatOption,
    AsyncPipe,
    TranslateModule,
    FormlyCostcenterSelectOptionsPipe,
    MatPseudoCheckbox,
  ],
})
export class FormlyCostcenterSelectComponent extends FormlyFieldSelect {
  override defaultOptions = {
    props: {
      compareWith(o1: any, o2: any) {
        return o1 === o2;
      },
    },
  };

  _getSelectAllState(options: any): MatPseudoCheckboxState {
    const tmp: any = super.getSelectAllState(options);
    if (tmp === '') {
      return 'unchecked';
    } else {
      return tmp;
    }
  }
}
